import {
  Flex,
  Center,
  Image,
  useMediaQuery,
  useColorMode,
  Heading,
  theme,
  Text,
  Container,
  IconButton,
  useColorModeValue,
  HStack
} from '@chakra-ui/react'

import { get } from 'js-cookie'
import {
  BottomNav,
  LangSelector,
  Notifications,
  ProfileButton,
  SideBar,
  CustomLink
} from 'components'
import { useAuthContext } from 'context/AuthProvider'
import { LANGUAGES } from '../../constants'
import { Property } from 'generated/graphql'
import React, { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { FiMoon, FiSun } from 'react-icons/fi'
import { useHistory } from 'react-router'
import { images } from 'theme'
import { useAppContext } from 'context/AppProvider'
import { PrimaryButton } from 'components/Buttons'
import Menu from './Menu'
import { VscArrowRight, VscHeart } from 'react-icons/vsc'

type NavProps = {
  isLoaded?: boolean
}

const Nav: React.FC<NavProps> = () => {
  const { toggleColorMode, colorMode } = useColorMode()
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const history = useHistory()
  const { isAuthenticated, user, logout, isAgent, isAdmin } = useAuthContext()
  const { isAdminMode } = useAppContext()
  const { t } = useTranslation()
  const afterBgPrimary = useColorModeValue('white', theme.colors.gray[800])

  const handleLogout = () => {
    logout && logout()
    history.push('/')
  }
  const { icon } = LANGUAGES.find((l) => l.code === get('lng')) || { code: 'en' }

  return (
    <>
      <Flex
        position="sticky"
        mt={[8, 20]}
        zIndex={48}
        left={0}
        width="100%"
        top={0}
        bg={afterBgPrimary}
      >
        <Container maxW="container.xl">
          <Flex align="center" justify="space-between">
            <Center
              cursor="pointer"
              onClick={() => history.push('/')}
              py={3}
              justifyContent="space-between"
            >
              <Center>
                <Image
                  src={colorMode === 'light' ? images.logo_purple : images.logo_white}
                  alt="nsoko property logo"
                  width={138}
                />
                {!isTabletOrMobile && (
                  <Heading as="h1" mx={3} size="sm">
                    Property
                  </Heading>
                )}
              </Center>
            </Center>
            <Menu />

            <HStack flex={1} spacing={6} justifyContent="flex-end">
              {isTabletOrMobile && !isAuthenticated ? null : (
                <LangSelector>
                  <Text fontSize="xs">
                    {icon} {get('lng')}
                  </Text>
                </LangSelector>
              )}
              {!isTabletOrMobile && (
                <IconButton
                  icon={colorMode === 'dark' ? <FiSun size={10} /> : <FiMoon size={10} />}
                  aria-label="Toggle color mode"
                  rounded="full"
                  onClick={toggleColorMode}
                  colorScheme="gray"
                />
              )}
              {isAuthenticated ? (
                <>
                  {!isTabletOrMobile && (
                    <Notifications
                      aria-label="Favorites"
                      icon={<VscHeart color={theme.colors.red[300]} />}
                      properties={user?.favorites_properties as Property[]}
                      title="Favorites"
                    />
                  )}
                  {!isTabletOrMobile && <ProfileButton user={user} onLogout={handleLogout} />}

                  {!isTabletOrMobile && (isAgent || isAdmin) && !isAdminMode ? (
                    <PrimaryButton
                      fontSize="xs"
                      colorScheme="orange"
                      rightIcon={<VscArrowRight />}
                      onClick={() => history.push('/auth/dashboard/agent/dashboard')}
                    >
                      Admin Panel
                    </PrimaryButton>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  {!isTabletOrMobile && (
                    <>
                      <CustomLink
                        title={t('sign_in')}
                        path="/login"
                        fontWeight="bold"
                        textTransform="uppercase"
                        letterSpacing={0.1}
                        fontSize={9}
                        active={history.location.pathname === '/login'}
                      />
                    </>
                  )}
                  <PrimaryButton
                    fontSize="xs"
                    colorScheme="orange"
                    ml={isTabletOrMobile ? 0 : 8}
                    rightIcon={<VscArrowRight />}
                    rounded="full"
                    onClick={() => history.push('/register', { prev: history.location.pathname })}
                  >
                    {t('get_strated')}
                  </PrimaryButton>
                </>
              )}

              {isTabletOrMobile && <SideBar />}
            </HStack>
          </Flex>
        </Container>
      </Flex>
      {isTabletOrMobile && <BottomNav />}
    </>
  )
}
Nav.defaultProps = {
  isLoaded: true
}
export default memo(Nav)
